import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// RxJS
import { catchError, switchMap, throwError } from 'rxjs';

// Services
import { AuthService } from '../services/auth.service';
import { ToastService } from '../../shared/services/toast.service';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const router = inject(Router);
    const authSrv = inject(AuthService);
    const toastSrv = inject(ToastService);

    // Lista di URL o pattern da escludere
    const excludedUrls = [
        '/auth/login',
        '/email/execute-reset-password',
        '/email/forgot-password',
        '/otp/start',
        '/otp/resend',
        '/otp/verify',
        'ip/verify-oob-code',
        '/auth/refresh' // evita loop sul refresh stesso
    ];

    if (excludedUrls.some(url => req.url.includes(url))) {
        return next(req);
    }

    const accessToken = authSrv.getAccessToken();
    let authReq = req;

    // Clone the request and add the authorization header
    if (accessToken) {
        authReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`
            }
        });
    }

    return next(authReq).pipe(
        catchError((error: any) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // 🔄 Prova il refresh token
                return authSrv.refreshToken().pipe(
                    switchMap((newToken: string) => {

                        // ❌ Se il refresh non restituisce un token, forza il logout
                        if (!newToken) {
                            router.navigate(['/auth/login']);
                            toastSrv.show({ type: 'error', message: 'La sessione è scaduta. Effettua nuovamente il login.' });
                            return throwError(() => 'Refresh failed');
                        }

                        // 🔁 Ripeti la richiesta originale con il nuovo token
                        const clonedReq = req.clone({
                            setHeaders: { Authorization: `Bearer ${newToken}` }
                        });

                        return next(clonedReq);
                    }),
                    catchError(refreshError => {
                        // ❌ Se anche il refresh fallisce, logout e redirect
                        router.navigate(['/auth/login']);
                        toastSrv.show({ type: 'error', message: 'Errore di sessione. Effettua nuovamente il login.' });
                        return throwError(() => refreshError);
                    })
                );
            }

            // Propaga altri errori
            return throwError(() => error);
        })
    );
};
